"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setEnvs = exports.setActiveSpaceId = exports.fetchMarketplaceApps = exports.setMarketPlaceApps = exports.getSpaceFeatures = exports.getSpaceInfo = exports.toggleRecordFullScreen = exports.toggleSideRecord = exports.toggleApiPanel = exports.setShortcutKeyPanelVisible = exports.setPreviewModalVisible = exports.setSideBarVisible = exports.setScreenWidth = exports.setConnected = exports.setReconnecting = exports.setSpaceFeatures = exports.setSpaceInfo = exports.setSpaceLoading = exports.setSpaceErr = exports.quitSpace = exports.setQuitSpaceId = exports.removeRedPoint = exports.setSpaceList = exports.spaceList = void 0;
const api_1 = require("../../../../exports/api");
const axios_1 = __importDefault(require("axios"));
const config_1 = require("../../../../config");
const store_1 = require("../../../../exports/store");
const catalog_tree_1 = require("./catalog_tree");
const user_1 = require("../../../user/store/actions/user");
/**
 * Get Space List
 */
const spaceList = () => {
    return (dispatch) => {
        api_1.Api.spaceList().then((res) => {
            const { success, data } = res.data;
            if (success) {
                dispatch((0, exports.setSpaceList)(data));
            }
        }, err => {
            console.error("API.spaceList error", err);
        });
    };
};
exports.spaceList = spaceList;
/**
 * Set Space List
 */
const setSpaceList = (data) => {
    return {
        type: store_1.ActionConstants.SET_SPACE_LIST,
        payload: data,
    };
};
exports.setSpaceList = setSpaceList;
/**
 * Remove Red dot
 * @param spaceId Space ID
 */
const removeRedPoint = (spaceId) => {
    return (dispatch) => {
        api_1.Api.removeSpaceRedPoint(spaceId).then((res) => {
            const { success } = res.data;
            if (success) {
                dispatch((0, exports.spaceList)());
            }
        }, err => {
            console.log('API.removeSpaceRedPoint error', err);
        });
    };
};
exports.removeRedPoint = removeRedPoint;
/**
 * set the space id will quite
 * @param spaceId
 */
const setQuitSpaceId = (spaceId) => {
    return {
        type: store_1.ActionConstants.SET_QUIT_SPACE_ID,
        payload: spaceId,
    };
};
exports.setQuitSpaceId = setQuitSpaceId;
/**
 * quit space
 * @param spaceId space ID
 */
const quitSpace = (spaceId) => {
    return (dispatch) => {
        api_1.Api.quitSpace(spaceId).then((res) => {
            const { success } = res.data;
            if (success) {
                dispatch((0, exports.setQuitSpaceId)(''));
                dispatch((0, catalog_tree_1.initCatalogTree)());
                dispatch((0, user_1.getUserMe)());
            }
        }, err => {
            console.log('API.quitSpace error', err);
        });
    };
};
exports.quitSpace = quitSpace;
/**
 * set space error info
 * @param err error info
 */
const setSpaceErr = (err) => {
    return {
        type: store_1.ActionConstants.SET_SPACE_ERR,
        payload: err,
    };
};
exports.setSpaceErr = setSpaceErr;
/**
 * set current loading state
 *
 * @param status current state
 */
const setSpaceLoading = (statu) => {
    return {
        type: store_1.ActionConstants.SET_SPACE_LOADING,
        payload: statu,
    };
};
exports.setSpaceLoading = setSpaceLoading;
/**
 * set current space info
 * @param spaceInfo
 */
const setSpaceInfo = (spaceInfo) => {
    return {
        type: store_1.ActionConstants.SET_SPACE_INFO,
        payload: spaceInfo,
    };
};
exports.setSpaceInfo = setSpaceInfo;
/**
 * set space features
 * @param spaceInfo
 */
const setSpaceFeatures = (data) => {
    return {
        type: store_1.ActionConstants.SET_SPACE_FEATURES,
        payload: data,
    };
};
exports.setSpaceFeatures = setSpaceFeatures;
const setReconnecting = (reconnecting) => {
    return {
        type: store_1.ActionConstants.SET_RECONNECTING,
        payload: reconnecting,
    };
};
exports.setReconnecting = setReconnecting;
const setConnected = (connected) => {
    return {
        type: store_1.ActionConstants.SET_CONNECTED,
        payload: connected,
    };
};
exports.setConnected = setConnected;
const setScreenWidth = (screenWidth) => {
    return {
        type: store_1.ActionConstants.SET_SCREEN_WIDTH,
        payload: screenWidth,
    };
};
exports.setScreenWidth = setScreenWidth;
const setSideBarVisible = (status) => {
    return {
        type: store_1.ActionConstants.SET_SIDEBAR_VISIBLE,
        payload: status,
    };
};
exports.setSideBarVisible = setSideBarVisible;
const setPreviewModalVisible = (status) => {
    return {
        type: store_1.ActionConstants.SET_PREVIEW_MODAL_VISIBLE,
        payload: status,
    };
};
exports.setPreviewModalVisible = setPreviewModalVisible;
const setShortcutKeyPanelVisible = (status) => {
    return {
        type: store_1.ActionConstants.SET_SHORTCUT_KEY_PANEL_VISIBLE,
        payload: status,
    };
};
exports.setShortcutKeyPanelVisible = setShortcutKeyPanelVisible;
const toggleApiPanel = (status) => {
    return {
        type: store_1.ActionConstants.TOGGLE_API_PANEL,
        payload: status,
    };
};
exports.toggleApiPanel = toggleApiPanel;
const toggleSideRecord = (status) => {
    return {
        type: store_1.ActionConstants.TOGGLE_SIDE_RECORD_PANEL,
        payload: status,
    };
};
exports.toggleSideRecord = toggleSideRecord;
const toggleRecordFullScreen = (status) => {
    return {
        type: store_1.ActionConstants.TOGGLE_RECORD_PANEL_FULL_SCREEN,
        payload: status,
    };
};
exports.toggleRecordFullScreen = toggleRecordFullScreen;
/**
 * get space info
 * @param spaceId
 * @param ignoreTimeLimit
 * @returns
 */
const getSpaceInfo = (spaceId, ignoreTimeLimit = false) => {
    return (dispatch, getState) => {
        var _a;
        const curSpace = getState().space;
        const lastUpdateTime = ((_a = curSpace === null || curSpace === void 0 ? void 0 : curSpace.curSpaceInfo) === null || _a === void 0 ? void 0 : _a.lastUpdateTime) || 0;
        // prevent too many requests.
        // after last call > 1 min
        if (!ignoreTimeLimit && (Date.now() - lastUpdateTime < 1000 * 60)) {
            return;
        }
        api_1.Api.spaceInfo(spaceId).then((res) => {
            const { data, success } = res.data;
            if (success) {
                dispatch((0, exports.setSpaceInfo)(Object.assign(Object.assign({}, data), { lastUpdateTime: Date.now() })));
            }
        }, err => {
            console.log('API.spaceInfo error', err);
        });
    };
};
exports.getSpaceInfo = getSpaceInfo;
/**
 * get workbench settings info
 * @returns
 */
const getSpaceFeatures = () => {
    return (dispatch) => {
        api_1.Api.getSpaceFeatures().then((res) => {
            const { data, success } = res.data;
            if (success) {
                dispatch((0, exports.setSpaceFeatures)(data));
            }
        }, err => {
            console.log('API.getSpaceFeatures error', err);
        });
    };
};
exports.getSpaceFeatures = getSpaceFeatures;
const setMarketPlaceApps = (apps) => {
    return {
        type: store_1.ActionConstants.SET_MARKETPLACE_APPS,
        payload: apps,
    };
};
exports.setMarketPlaceApps = setMarketPlaceApps;
/**
 * get space's 3rd apps list
 * @param spaceId
 * @returns
 */
const fetchMarketplaceApps = (spaceId) => {
    return (dispatch) => {
        if (!(0, config_1.getCustomConfig)().SPACE_INTEGRATION_PAGE_VISIBLE) {
            dispatch((0, exports.setMarketPlaceApps)([]));
            return;
        }
        api_1.Api.getMarketplaceApps(spaceId).then((res) => {
            const { success, data } = res.data;
            if (success) {
                dispatch((0, exports.setMarketPlaceApps)(data));
            }
        }, err => {
            console.log('API.getMarketplaceApps error', err);
        });
    };
};
exports.fetchMarketplaceApps = fetchMarketplaceApps;
const setActiveSpaceId = (spaceId) => {
    if (spaceId) {
        axios_1.default.defaults.headers.common['X-Space-Id'] = spaceId;
    }
    return {
        type: store_1.ActionConstants.SET_ACTIVE_SPACE_ID,
        payload: spaceId,
    };
};
exports.setActiveSpaceId = setActiveSpaceId;
const setEnvs = (envs) => {
    return {
        type: store_1.ActionConstants.SET_ENVS,
        payload: envs,
    };
};
exports.setEnvs = setEnvs;
//# sourceMappingURL=space.js.map